import { render, staticRenderFns } from "./floorSkuCoverSetting.vue?vue&type=template&id=4e24d9c3&scoped=true"
import script from "./floorSkuCoverSetting.vue?vue&type=script&lang=js"
export * from "./floorSkuCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./floorSkuCoverSetting.vue?vue&type=style&index=0&id=4e24d9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24d9c3",
  null
  
)

export default component.exports